module.exports = __webpack_public_path__ + "static/img/1.64d306f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/8/1.png
// module id = 1CTS
// module chunks = 0